import { render } from "./DeathSimulator.vue?vue&type=template&id=278378c4&scoped=true"
import script from "./DeathSimulator.vue?vue&type=script&lang=js"
export * from "./DeathSimulator.vue?vue&type=script&lang=js"

import "./DeathSimulator.vue?vue&type=style&index=0&id=278378c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278378c4"]])

export default __exports__